import { React } from "react";
import { Link } from "react-router-dom";
import logo from "../../../../assets/images/logo_orange.svg";

const DashboardLogo = () => {
  return (
    <div className="logo-container">
      <Link to="/dashboard">
        <img src={logo} alt="Astronomic logo" className="dashboard-logo" />
      </Link>
    </div>
  );
};

export default DashboardLogo;
